

module.directive('criminalJusticeForm', function(ModelService) {
    var fields = ['offender_at_entry', 'court_involved_at_entry',
                  'level_of_offense', 'court_involved_incident',
                  'court_involved_incident_date', 'release_date'];
    return {
        restrict: 'E',
        templateUrl: 'students/demographics/criminalJusticeForm',
        scope: {cj: '=', student: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            var data = ModelService.copyFields(scope.cj, fields);
            scope.data = basicForm.data = data;
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.cj, data);
            };
        },
    };
});


module.directive('criminalJusticeEarlyForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/demographics/criminalJusticeEarlyForm',
        scope: {cj: '=', student: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            var data = ModelService.copyFields(scope.cj, [
                'court_involved_incident', 'court_involved_incident_date']);
            scope.data = basicForm.data = data;
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.cj, data);
            };

            basicForm.setDeleteFunctions(function() {
                ModelService.patchModel(scope.cj, {
                    court_involved_incident: null,
                    court_involved_incident_date: null,
                });
            }, function() {
                return !!scope.cj.court_involved_incident;
            });
        },
    };
});